export function getHistoryStateObject() {
  try {
    const base = window.history && window.history.state
    if (base && typeof base === 'object') return base
  } catch {}
  return {}
}

export function safePushState(payload, url) {
  try {
    const base = getHistoryStateObject()
    const nextState = { ...base, ...(payload || {}) }
    if (typeof url === 'string') {
      window.history.pushState(nextState, '', url)
    } else {
      window.history.pushState(nextState, '')
    }
    return true
  } catch {}
  return false
}

export function safeReplaceState(payload, url) {
  try {
    const base = getHistoryStateObject()
    const nextState = { ...base, ...(payload || {}) }
    if (typeof url === 'string') {
      window.history.replaceState(nextState, '', url)
    } else {
      window.history.replaceState(nextState, '')
    }
    return true
  } catch {}
  return false
}

